import React from "react";
import Navigation from "../components/Navbar";
import contactStyle from "../styles/ContactPage.module.css";

import linkedin from "../assests/svg/linkedin.svg";
import twitter from "../assests/svg/twitter.svg";
import instagram from "../assests/svg/instagram.svg";
import facebook from "../assests/svg/facebook.svg";
import email from "../assests/images/Vector-8.png";
import Footer from "../components/Footer";
import Seo from "../components/Seo";

function Contact() {
  const calendly = "https://calendly.com/cloudare";

  return (
    <>
        <Seo path="/contact-us" />
      <Navigation />

      <section className={contactStyle.contactSection}>
        <h1 className={contactStyle.contactTitle}>Get in Touch</h1>

        <p className={contactStyle.contactSubtitle}>
          We’d love to hear from you. Reach out to us anytime.
        </p>

        <div className={contactStyle.contactCard}>
          <h3 className={contactStyle.cardHeading}>Contact Information</h3>

          <a
            href={calendly}
            target="_blank"
            rel="noopener noreferrer"
            className={contactStyle.calendlyBtn}
          >
            Book a Free Consultation
          </a>

          <p className={contactStyle.contactItem}>
            📧 Email:
            <a
              href="mailto:hello@cloudare.in"
              className={contactStyle.contactLink}
            >
              {" "}
              hello@cloudare.in
            </a>
          </p>

          <p className={contactStyle.contactItem}>
            📞 Phone:
            <a
              href="https://wa.me/+16282825683"
              target="_blank"
              rel="noopener noreferrer"
              className={contactStyle.contactLink}
            >
              {" "}
              +1 628-282-5683
            </a>
          </p>

          <div className={contactStyle.socialLogosContainer}>
            <a
              href="https://www.linkedin.com/company/cloudare"
              target="_blank"
              rel="noopener noreferrer"
              className={contactStyle.socialIcon}
            >
              <img src={linkedin} alt="LinkedIn" />
            </a>

            <a
              href="https://x.com/CloudareGlobal"
              target="_blank"
              rel="noopener noreferrer"
              className={contactStyle.socialIcon}
            >
              <img src={twitter} alt="Twitter" />
            </a>

            <a
              href="https://www.instagram.com/cloudaretechnologies/"
              target="_blank"
              rel="noopener noreferrer"
              className={contactStyle.socialIcon}
            >
              <img src={instagram} alt="Instagram" />
            </a>

            <a
              href="https://www.facebook.com/cloudaretech"
              target="_blank"
              rel="noopener noreferrer"
              className={contactStyle.socialIcon}
            >
              <img src={facebook} alt="Facebook" />
            </a>

            <a
              href="mailto:hello@cloudare.in"
              className={contactStyle.socialIcon}
            >
              <img src={email} alt="Email" />
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Contact;
